import React, { useContext } from 'react'
import { PrimaryButton } from '../../../components/button/button'
import { Autorenew } from '@mui/icons-material'
import { Grid, styled } from '@mui/material'
import { fireTaskApi } from '../services/activityApi'
import { useSnackbar } from 'notistack'
import { SNACK_VARIANT } from '../../../utils/constants'
import { useIntl } from 'react-intl'
import { AppModel } from '../../appData/appModel'
import { AppContext } from '../../appData/AppContext'
import ConfirmDialog from '../../../components/dialog/ConfirmDialog'
import { useModalState } from '../../../utils/hookUtils'

const AlignedRightContainer = styled(Grid)({
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: '16px',
    paddingTop: '16px'
})

type taskProgressError = {
	bodyError: taskProgressBodyError
}

type taskProgressBodyError = {
	globalErrors: GlobalError[]
}

type GlobalError = {
	messageId: string
}

const ProcessButton: React.FC = () => {
    const intl = useIntl()
    const { enqueueSnackbar } = useSnackbar()
    const { handleTaskInProgress } = useContext<AppModel>(AppContext)
	const { open, openModal, closeModal } = useModalState(false)

    const fireTask: any = () => {
        return fireTaskApi()
            .then(handleTaskInProgress)
            .catch((e: taskProgressError) => {
				e.bodyError.globalErrors.map((error) =>
	                enqueueSnackbar(
						intl.formatMessage({
							id: error.messageId,
							description: 'error'
						}),
		                { variant: SNACK_VARIANT.ERROR }
	                )
				)
			})
	        .finally(closeModal)
    }

    return <AlignedRightContainer item container>
        <PrimaryButton
            label="global.buttons.process"
            onClick={openModal}
            icon={<Autorenew />}
        />
	    <ConfirmDialog
		    open={open}
		    title={`process.modal.title`}
		    description={`process.modal.description`}
		    confirmLabel={`process.modal.confirm`}
		    confirmLoading={false}
		    confirmClick={fireTask}
		    onClose={closeModal}
	    />
    </AlignedRightContainer>
}

export default ProcessButton
